import Cookie from '../../helpers/cookie';

const Modal = {
    class: {
        active: 'modal--active',
        open: 'modal--open'
    },
    open: ref => {
        const id = ref.target.dataset.modalOpen;
        const modal = document.querySelector(`[data-modal-id="${id}"]`);
        Modal.reset([Modal.class.active, Modal.class.open]);
        ref.target.classList.add(Modal.class.active);
        modal.classList.add(Modal.class.open);
    },
    close: (ref, hasCookie = false, cookieName = null) => {
        Modal.reset([Modal.class.active, Modal.class.open]);
        if (hasCookie === true) {
            Cookie.create(cookieName, true);
        }
    },
    reset: refs => {
        refs.forEach(ref => {
            const elements = document.getElementsByClassName(ref);
            while (elements[0]) {
                elements[0].classList.remove(ref);
            }
        });
    },
    init: () => {
        const openers = document.querySelectorAll('[data-modal-open]');
        const closers = document.querySelectorAll('[data-modal-close]');
        const closeCookieAgreements = document.querySelectorAll('.cookie-agreement');
        const cookieAgreementModal = document.querySelector('.modal--cookie-agreement');
        const getCookieAgreement = Cookie.read('cookie-agreement');

        // Cookie Agreement
        if (cookieAgreementModal && getCookieAgreement === null) {
            cookieAgreementModal.classList.add(Modal.class.open);
        }

        closeCookieAgreements.forEach(closeCookieAgreement => {
            closeCookieAgreement.addEventListener('click', el => {
                el.preventDefault();
                Modal.close(el, true, 'cookie-agreement');
            });
        });

        // Events for all modal links
        openers.forEach(opener => {
            opener.addEventListener('click', el => {
                el.preventDefault();
                Modal.open(el);
            });
        });

        // Events for all modal close buttons
        closers.forEach(closer => {
            closer.addEventListener('click', el => {
                el.preventDefault();
                Modal.close(el);
            });
        });
    }
};

export default Modal;
